/*=========================================================================================
  File Name: moduleContactState.js
  Description: Contact Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  contacts: []
}
  